import {
  AllDealActions,
  DealAction,
  DealCardAction,
  DealDispatcherPayload,
  DealHeaderFeaturedCommentAction,
} from '@pelando/components';
import {
  GeneralDealEvents,
  EventCategory,
} from '../../../../../domain/events/analytics';
import { emitTrackingEvent } from '../../../../../infra/analytics/emitTrackingEvent';
import { emitGoToDealDetailsEvent } from '../../../../services/events';
import { DealCardComponentNames } from '../../../../services/events/componentNames';

import {
  getCouponsUrl,
  getDealUrlWithComment,
} from '../../../../services/urls';
import { OfferKind, OfferStatus } from '../../../../../domain/entities/Offer';

export type DealActions = {
  type: AllDealActions;
  payload: DealDispatcherPayload<AllDealActions>;
};

type ActionHandlerProps = {
  action: DealActions;
  push: (url: string) => Promise<boolean>;
  kind?: OfferKind;
  status?: OfferStatus;
  dealId?: string;
  title?: string;
  storeName?: string;
  dealUrl: string;
  cardPosition: number;
  locale?: string;
};

const actionHandlerClickouts = ({
  action,
  push,
  locale,
  dealId = '',
  title = '',
  storeName,
  dealUrl,
  cardPosition,
}: ActionHandlerProps) => {
  switch (action.type) {
    case DealAction.CLICK_SEE_DEAL:
      emitGoToDealDetailsEvent(
        DealCardComponentNames.SeeDealButton,
        dealId,
        cardPosition
      );
      push(dealUrl);
      break;

    case DealAction.CLICK_COMMENTS:
      emitTrackingEvent({
        name: GeneralDealEvents.ClickToViewComments,
        category: EventCategory.GeneralDeal,
        extra: undefined,
      });
      emitGoToDealDetailsEvent(
        DealCardComponentNames.CommentsIconButton,
        dealId,
        cardPosition
      );

      break;

    case DealCardAction.ON_IMAGE_CLICK:
      emitGoToDealDetailsEvent(
        DealCardComponentNames.Image,
        dealId,
        cardPosition
      );

      break;

    case DealCardAction.ON_STORE_CLICK:
      if (storeName) {
        emitTrackingEvent({
          category: EventCategory.GeneralDeal,
          name: GeneralDealEvents.ClickToGoToStorePage,
          extra: { store: storeName },
        });
      }

      push(
        getCouponsUrl({
          ...(action.payload as DealDispatcherPayload<DealCardAction.ON_STORE_CLICK>),
          locale,
        })
      );

      break;

    case DealCardAction.ON_TITLE_CLICK:
      emitGoToDealDetailsEvent(
        DealCardComponentNames.Title,
        dealId,
        cardPosition
      );

      break;

    case DealHeaderFeaturedCommentAction.ON_HEADER_COMMENT_CLICK:
      push(
        getDealUrlWithComment({
          ...(action.payload as DealDispatcherPayload<DealHeaderFeaturedCommentAction.ON_HEADER_COMMENT_CLICK>),
          title,
          dealId,
        })
      );
      emitTrackingEvent({
        name: GeneralDealEvents.ClickToViewComments,
        category: EventCategory.GeneralDeal,
        extra: undefined,
      });
      emitGoToDealDetailsEvent(
        DealCardComponentNames.HeaderComment,
        dealId,
        cardPosition
      );

      break;
    default:
      break;
  }
};

export default actionHandlerClickouts;
